@if (showPrompt && !isLoading) {
  <div class="mfa-prompt-container">
    <div class="mfa-prompt-content">
      <div class="mfa-prompt-icon">
        <i class="bi bi-shield-lock-fill"></i>
      </div>
      <div class="mfa-prompt-text">
        <h5>Enhance Your Account Security</h5>
        <p>Two-Factor Authentication (MFA) adds an extra layer of security to your account. Enable it now to protect your data.</p>
        <div class="mfa-prompt-actions">
          <button type="button" class="mfa-prompt-btn mfa-prompt-btn-primary" (click)="setupMfa()">
            <i class="bi bi-shield-fill-check me-1"></i>Set Up MFA
          </button>
          <button type="button" class="mfa-prompt-btn mfa-prompt-btn-secondary" (click)="dismissPrompt()">
            <i class="bi bi-clock-history me-1"></i>Later
          </button>
        </div>
      </div>
    </div>
    <button type="button" class="mfa-prompt-close" (click)="dismissPrompt()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
}